export type SortDirection = 'asc' | 'desc';

export type Department = 'NATIONAL' | 'INTERNATIONAL' | 'DEPUTIZATION' | 'UIDDA' | 'DUE_DILIGENCE';

export type ServiceType = 'PROCESS_SERVICE' | 'HOUSE_INSPECTION' | 'DUE_DILIGENCE_INQUIRY' | 'DELIVERY';

export type InvoiceStatus = 'DRAFT' | 'PAID' | 'REVIEWED' | 'CONFIRMED';
export enum AdvanceFilterOperator {
  EQUALS = 'EQUALS',
  CONTAINS = 'CONTAINS',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
}

export enum AdvanceFilterFieldType {
  STRING = 'STRING',
  ID = 'ID',
  DATE = 'DATE',
}

export const FilterTypeOperatorMap = {
  ID: [AdvanceFilterOperator.EQUALS],
  STRING: [AdvanceFilterOperator.CONTAINS, AdvanceFilterOperator.EQUALS],
  DATE: [
    AdvanceFilterOperator.GREATER_THAN,
    AdvanceFilterOperator.GREATER_THAN_OR_EQUAL_TO,
    AdvanceFilterOperator.LESS_THAN,
    AdvanceFilterOperator.LESS_THAN_OR_EQUAL_TO,
    AdvanceFilterOperator.EQUALS,
  ],
};

export type AdvanceFilter = {
  field?: string;
  operator?: AdvanceFilterOperator;
  value?: string;
  fieldType?: AdvanceFilterFieldType;
};

export type AdvanceFilterConfig = {
  value: string;
  label: string;
  fieldType: AdvanceFilterFieldType;
  inputType: 'INPUT' | 'SELECT' | 'DATE';
  customFilterTypeOperator?: AdvanceFilterOperator[];
};
export interface MediaBaseResponse {
  mediaId: string;
  type: string;
  mimeType: string;
  bucketName: string;
  path: string;
  baseUrl: string;
  metadata: { fileName: string };
  uploadedById: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
}

export enum EmailStatus {
  SENT = 'SENT',
  FAILED = 'FAILED',
}
export interface EmailLogResponse {
  id: string;
  sentAt: string;
  status: EmailStatus;
}

export interface User {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface DocumentListType {
  name: string;
  media: MediaBaseResponse;
  /**
   * Process-billing proof id (vendor `processBillingVendorDocumentId` or server
   * `processBillingDocumentId`). When set together with `onRequestSendAffidavit` on
   * `DocumentListDialog`, the list row shows send for that file only.
   */
  affidavitSendDocumentId?: string;
}
export interface ApiResponse<T> {
  data: T;
  success: boolean;
  message?: string;
}

export interface ApiError {
  error: string;
  details?: string;
  statusCode: number;
}

export type ListPageResponse<Key extends string, Value> = {
  currentPage: number;
  totalPages: number;
  totalRows: number;
} & {
  [K in Key]: Value[];
};
